<template>
  <!-- comment-item -->
  <section>
    <modal-likes :targetItem="propComment" ref="modalLikes"/>
    <div class="flex-box parent-comment" :class="{ clicked: isClickedComment}">
      <span class="info-userimg">
      <template v-if="getUserInfoById(propComment.userId).isDeleted">
        <span class="isExistUnread">
          <img v-if="getUserInfoById(propComment.userId).userIcon" :src="getUserInfoById(propComment.userId).userIcon" alt="image" class="img-circle">
          <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
        </span>
      </template>
      <template v-else>
        <router-link :to="{ name: 'User', params: { userId: propComment.userId }}">
          <span class="isExistUnread">
            <img v-if="getUserInfoById(propComment.userId).userIcon" :src="getUserInfoById(propComment.userId).userIcon" alt="image" class="img-circle">
            <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
          </span>
        </router-link>
      </template>
      </span>
      <div class="comment detail-head">
        <div class="info-userelement">
          <span class="info-username">{{ getUserInfoById(propComment.userId).userName }}</span>
          <span class="info-time">
            {{propComment.createdAt | preparedTime}}
          </span>
        </div>
        <div v-if="propComment.isDelete">{{ getContentText }}</div>
        <div v-else-if="propComment.isStamp" class="show-stamp">
          <img :src="getStampImg(propComment.isStamp)" :alt="propComment.isStamp">
        </div>
        <read-more v-else :targetId="propComment.id" :isGrayOut="!!propComment.isDelete" :text="getContentText" :addMore="true" :showMore="this.propShowMore" :contentHeight="this.propContentHeight" @update-show-more="updateShowMore" @update-content-height="updateContentHeight">
          {{ getContentText }}
        </read-more>
        <image-viewer v-if="propComment.uploadedFile" :uploadedFile="propComment.uploadedFile" />
        <div class="child-tools">
          <span class="info-menu">
            <a @click.stop="onClickReply('parent', propComment.id)" class="info-comment-detail collapse-reply">
              <i class="fa fa-mail-reply fa-rotate-180"></i>
            </a>
            <a class="info-comment" v-if="!propComment.isDelete">
              <img v-if="isLiked(propComment)" @click.stop="onClickStarLiked(propComment, propComment.id)" :src="'static/img/assets/nice_on.png'">
              <img v-else @click.stop="onClickStarNotLiked(propComment, propComment.id)" :src="'static/img/assets/nice_off.png'">
              <span class="like-counter" @click.stop="showModalLikes(propComment)" v-if="propComment.likes"><strong v-bind:class="{ unread: isUnreadLikeExist(propComment.id, propComment.userId, propComment.likes) }">{{ propComment.likes ? Object.keys(propComment.likes).length : 0 }}</strong><span>{{ $t('likesCountStr') }}</span></span>
            </a>
          </span>
          <span v-if="checkCommentIsDelete(propComment)" class="info-right">
            <comment-drop-down @comment-delete="commentDelete(propComment, 'parent')"/>
          </span>
        </div>
      </div>
    </div>
    <div v-for="child in getChildComments" :key="child.id" :class="{clicked: child.id === clickedCommentId}">
      <child-comment-item :propChildComment="child" @call-set-reply="onCallClickReply"/>
    </div>
  </section>
  <!-- /comment-item -->
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CommentDropDown from '@/components/Comment/CommentDropDown'
import ReadMore from '@/components/ReadMore/ReadMoreComponent'
import moment from 'moment'
import ChildCommentItem from '@/components/Comment/ChildCommentItem'
import ModalLikes from '@/components/Comment/ModalLikes'
import ImageViewer from '@/components/Fb/ImageViewer'
import { stampsurl } from '@/main'

export default {
  name: 'CommentItem',
  props: {
    propComment: Object,
    isDetailViewOpen: {
      type: Boolean,
      default: true
    },
    isClickedComment: {
      type: Boolean,
      default: false
    },
    clickedCommentId: {
      type: String,
      default: ''
    }
  },
  components: {
    CommentDropDown,
    ReadMore,
    ChildCommentItem,
    ModalLikes,
    ImageViewer
  },
  data () {
    return {
      options: {
        showCounter: false,
        widthRatio: 0.5,
        heightRatio: 0.5,
        nav: false,
        close: false
      },
      propShowMore: false,
      propContentHeight: 0,
      // childShowMore: false,
      // childContentHeight: 0,
      // tmpData: {}, // 新しくkeyを追加した時はリアクティブにならないのでobject型
      // Reloadstamps: {}
      childShowMore: false
    }
  },
  computed: {
    ...mapGetters([
      'getUserId'
    ]),
    ...mapGetters('comments/', [
      'getChildCommentsByParentId',
      'getIsReadLikeComment'
    ]),
    ...mapGetters('users/', [
      'getUserInfoById'
    ]),
    getChildComments () {
      return this.getChildCommentsByParentId(this.propComment.id, this.propComment.target)
    },
    getContentText () {
      if (!this.propComment.isDelete) {
        return this.propComment.contentText
      } else {
        return this.$t('deletedComentStr')
      }
    }
  },
  updated: function () {
    console.log(this.propComment.userId)
  },
  methods: {
    ...mapActions({
      setReadTime: 'setReadTime'
    }),
    ...mapActions('comments/', {
      removeCommnet: 'REMOVE_COMMENT',
      setLikes: 'SET_LIKES',
      removeLikes: 'REMOVE_LIKES'
    }),
    checkCommentIsDelete: function (comment) {
      if (comment.userId === this.getUserId && !comment.isDelete) {
        return true
      } else {
        return false
      }
    },
    onCallClickReply: function (value) {
      const parentItem = value
      console.log('parentItem::::', parentItem)
      this.onClickReply(parentItem.item, parentItem.id)
    },
    getStampImg (key) {
      var url = stampsurl.host + '/stamp/' + key
      return url
    },
    onClickReply: function (value, itemId) {
      let parentItem
      if (value === 'parent') {
        parentItem = {
          item: this.propComment,
          id: itemId
        }
        this.$emit('set-reply', parentItem)
      } else {
        parentItem = {
          item: value,
          id: itemId
        }
        this.$emit('set-reply', parentItem)
      }
    },
    onClickStarNotLiked: function (comment, key) {
      this.setLikes({
        key: key,
        userId: this.getUserId
      })
    },
    onClickStarLiked: function (comment, key) {
      this.removeLikes({
        key: key,
        userId: this.getUserId
      })
    },
    onClickStarToggle: function (comment, key) {
      if (this.isLiked(comment)) {
        this.onClickStarLiked(comment, key)
      } else {
        this.onClickStarNotLiked(comment, key)
      }
    },
    isUnreadLikeExist (commentKey, commentOwnerId, likeOwners) {
      for (let likeOwner in likeOwners) {
        if (!this.getIsReadLikeComment(commentOwnerId, commentKey, likeOwner)) {
          return true
        }
      }
      return false
    },
    isLiked: function (comment) {
      if (!comment.likes) {
        return false
      } else {
        return Object.keys(comment.likes).filter(x => x === this.getUserId).length !== 0
      }
    },
    showModalLikes (comment) {
      for (let likeOwner in comment.likes) {
        if (!this.getIsReadLikeComment(comment.userId, comment.id, likeOwner)) {
          this.setReadTime({
            itemType: 'likes',
            targetType: 'comments',
            targetOwner: comment.userId,
            targetId: comment.id,
            likeOwner: likeOwner,
            readTime: new Date().getTime()
          })
        }
      }
      this.$refs.modalLikes.showModal()
    },
    commentDelete: function (comment, string) {
      let deleteInfo = {}
      console.log(this.getChildCommentsByParentId(comment.id, comment.target))
      if (this.getChildCommentsByParentId(comment.id, comment.target).length > 0) {
        deleteInfo = {
          parentId: 'parent',
          commentId: comment.id,
          targetId: comment.targetId,
          target: comment.target,
          userId: comment.userId,
          targetOwner: comment.targetOwner,
          remtext: this.$t('deletedComentStr')
        }
      } else {
        deleteInfo = {
          parentId: 'notParent',
          commentId: comment.id,
          targetId: comment.targetId,
          target: comment.target,
          userId: comment.userId,
          targetOwner: comment.targetOwner,
          remtext: this.$t('deletedComentStr')
        }
      }
      if (comment.uploadedFile) {
        console.log('deleteInfo add deleteimage')
        deleteInfo.uploadedFile = comment.uploadedFile
      }
      this.removeCommnet(deleteInfo)
    },
    updateShowMore: function (value) {
      this.propShowMore = value
    },
    updateContentHeight: function (value) {
      this.propContentHeight = value
    },
    onClickDelete: function () {
      this.$emit('call-delete')
    }
  },
  filters: {
    preparedTime: function (date) {
      return moment(date * 1000).format('YYYY/MM/DD HH:mm')
    },
    momentDay: function (date) {
      return moment(date).format('YYYY/MM/DD')
    },
    momentTime: function (date) {
      return moment(date).format('HH:mm:ss')
    }
  }
}
</script>
<style scoped>
.parent-comment {
  padding-bottom: 10px;
}
.clicked{
  border-color: #F0E0E0;
  border-style: solid;
  border-width: 10px;
}
.modal-enter-active, .modal-leave-active {
  transition: all .2s ease ;
}
.modal-enter, .modal-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Comment/CommentItem.vue